var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuifang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "06_\u4ECA\u65E5\u5F85\u968F\u8BBF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.69,6.9H19.4a2.08,2.08,0,0,0-1.51.63A2.12,2.12,0,0,0,17.26,9a2.14,2.14,0,0,0,2.14,2.15H47l-9.69,5.63-.89.6a2.12,2.12,0,0,0-1.06,1.8V46.05H19.4a2.14,2.14,0,0,0-1.51,3.66,2.12,2.12,0,0,0,1.51.63H35.33V55a2.14,2.14,0,0,0,2.15,2.14,1.77,1.77,0,0,0,1.06-.35l1.06-.63,0,.05,15.25-9,.88-.6a1.86,1.86,0,0,0,.71-.68l.07-.13a1.68,1.68,0,0,0,.31-1V9a2.16,2.16,0,0,0-1.31-2,2.4,2.4,0,0,0-.84-.15ZM39.52,21l13.1-7.29V43.07l-13.1,7.6V21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.83,19.44a2.12,2.12,0,0,0-1.51.63,2.15,2.15,0,0,0,0,3l3.36,3.36H9.31A2.14,2.14,0,0,0,7.16,28.6a2.12,2.12,0,0,0,.63,1.52,2.16,2.16,0,0,0,1.52.63H21.68l-3.36,3.36a2.15,2.15,0,0,0,0,3,2.1,2.1,0,0,0,1.54.65h0a2.07,2.07,0,0,0,1.49-.63l7.05-7a2.14,2.14,0,0,0,0-3l-7-7a2.16,2.16,0,0,0-1.52-.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuifang);
export default __webpack_public_path__ + "static/media/suifang.ac0e7285.svg";
export { ForwardRef as ReactComponent };